import { render } from "./LoginComponent.vue?vue&type=template&id=08e49d82&scoped=true"
import script from "./LoginComponent.vue?vue&type=script&lang=js"
export * from "./LoginComponent.vue?vue&type=script&lang=js"

import "./LoginComponent.vue?vue&type=style&index=0&id=08e49d82&scoped=true&lang=css"

import exportComponent from "C:\\www\\farming_chat_pc_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08e49d82"]])

export default __exports__